import { type Nullable } from "@/types";
import { isDevelopment } from "@/utils/env.ts";
import { type ChoiceWithPossibleIndicator, FilterType, type FilterTypeEnum, type PropertyConfigCode } from "../types";
import { Filter } from "./filters";

type Props = {
    filterType: FilterTypeEnum;
    choices: ChoiceWithPossibleIndicator[];
    configCode: Nullable<PropertyConfigCode>;
    onClick: (configCode: Nullable<PropertyConfigCode>, isPossible: boolean) => void;
};

export default function SubFamilyFilter({ filterType, choices, configCode, onClick }: Props) {
    switch (filterType) {
        case FilterType.Radio:
        case FilterType.RadioImages:
        case FilterType.SingleSelectCheckboxes:
            return <Filter type={filterType} props={{ choices: choices, configCode, onClick }} />;

        default:
            // eslint-disable-next-line i18next/no-literal-string
            if (isDevelopment()) return <div>{filterType} not implemented!</div>;
            return null;
    }
}
